angular.module('smartorg.r6.mgmts.createPortfolio', []);
require('./create-portfolio-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.createPortfolio';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/create-portfolio/app/js/plumbing/app.js